.modal {
  max-width: 500px;

  > div > span {
    width: 100%;
  }

  > div {
    justify-content: start;
    align-items: normal;
  }
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 15px;
  gap: 5px;
}

.icon {
  border-radius: 15%;
  height: 55px;
  width: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

  @include themify($themes) {
    background-color: rgba(themed("error-primary"), 0.25);
  }

  svg {
    width: 42px;
    height: 42px;

    @include themify($themes) {
      color: themed("error-primary");
    }
  }
}

.body {
  padding: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0;

  p {
    font-size: 15px;
    line-height: 1.6;
    margin: 0;

    @include themify($themes) {
      color: themed("main-primary-opacity-high");
    }
  }
}

.warning {
  font-weight: 600;

  @include themify($themes) {
    color: themed("error-primary");
  }
}

.buttons {
  justify-content: center;
  gap: 20px;

  [data-testid="uninstall-slack-confirm"] {
    @include themify($themes) {
      background-color: rgba(themed("error-primary"), 0.9);
      color: themed("main-secondary");
    }

    &:hover {
      @include themify($themes) {
        background-color: themed("error-primary");
      }
    }
  }
}
